/* Reveal-on-scroll for .rr .rv, on every page. The same contract as core-pdp.js and learn.js, which only load with certain sections:
   a page built without them left every .rv block invisible. Safe to run beside them: adding .in twice changes nothing.
   Checks on scroll as well as through IntersectionObserver, so a block is never left hidden if the observer does not fire. */
(function () {
  if (window.__rrReveal) return; window.__rrReveal = true;
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null, queued = false;
  var sweep = function () {
    queued = false;
    var left = document.querySelectorAll('.rr .rv:not(.in)');
    if (!left.length) return;
    var edge = innerHeight * 0.92;
    left.forEach(function (el) { var r = el.getBoundingClientRect(); if (reduced || (r.top < edge && r.bottom > -40) || r.bottom < 0) el.classList.add('in'); });
  };
  var onScroll = function () { if (queued) return; queued = true; setTimeout(sweep, 60); };
  var run = function () {
    sweep();
    if ('IntersectionObserver' in window && !reduced) {
      if (!io) io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.rr .rv:not(.in)').forEach(function (el) { io.observe(el); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
